import { useTranslation } from 'react-i18next'
import type { PersonelDetail } from '../model'
import { KvRow, SectionCard } from './SectionCard'
import { TokenDonut } from './TokenDonut'

function Legend({ dot, value, label }: { dot: string; value: number; label: string }) {
  return (
    <div className="flex items-center gap-2">
      <span className={`size-2 rounded-full ${dot}`} />
      <span className="text-muted-foreground">
        <span className="font-semibold text-foreground">{value}</span> {label}
      </span>
    </div>
  )
}

export function BelgeSidePanel({ belge }: { belge: PersonelDetail['belge'] }) {
  const { t } = useTranslation()
  const { sozlesme, ozet } = belge
  return (
    <div className="space-y-4">
      <SectionCard title={t('hr.personel.belge.sozlesme')}>
        <KvRow label={t('hr.personel.belge.baslangic')} value={sozlesme.baslangic} />
        <KvRow label={t('hr.personel.belge.bitis')} value={sozlesme.bitis} />
        <KvRow label={t('hr.personel.fields.istihdam')} value={t(`hr.personel.form.options.istihdam.${sozlesme.istihdam}`)} />
        <KvRow label={t('hr.personel.belge.sozlesmeTip')} value={sozlesme.tip} />
        <KvRow label={t('hr.personel.belge.deneme')} value={sozlesme.deneme} />
      </SectionCard>

      <SectionCard title={t('hr.personel.belge.tamamlanma')}>
        <div className="flex items-center gap-4">
          <TokenDonut pct={ozet.pct} size={96} />
          <div className="min-w-0 flex-1 space-y-2.5 text-[13px]">
            <Legend dot="bg-success" value={ozet.tamam} label={t('hr.personel.belge.legend.tamam')} />
            <Legend dot="bg-destructive" value={ozet.eksik} label={t('hr.personel.belge.legend.eksik')} />
            <Legend dot="bg-muted-foreground/40" value={ozet.suresi_gecen} label={t('hr.personel.belge.legend.gecen')} />
          </div>
        </div>
      </SectionCard>

      <SectionCard title={t('hr.personel.belge.eksik')}>
        <div className="space-y-2">
          {belge.eksik.length === 0 ? (
            <p className="text-sm text-muted-foreground">{t('hr.personel.belge.eksikYok')}</p>
          ) : (
            belge.eksik.map((b) => (
              <div
                key={b.id}
                className="flex items-center justify-between gap-2 rounded-xl border border-destructive/20 bg-destructive/5 px-3 py-2.5 text-sm"
              >
                <span className="font-medium">{b.ad}</span>
                <span className="inline-flex rounded-full bg-destructive/12 px-2 py-0.5 text-xs font-medium text-destructive">
                  {t('hr.personel.belge.durum.eksik')}
                </span>
              </div>
            ))
          )}
        </div>
      </SectionCard>

      <SectionCard title={t('hr.personel.belge.yaklasan')}>
        <div className="space-y-2">
          {belge.yaklasan.length === 0 ? (
            <p className="text-sm text-muted-foreground">{t('hr.personel.belge.yaklasanYok')}</p>
          ) : (
            belge.yaklasan.map((b) => (
              <div
                key={b.id}
                className="flex items-start justify-between gap-2 rounded-xl border border-warning/25 bg-warning/10 px-3 py-2.5 text-sm"
              >
                <div className="min-w-0">
                  <div className="truncate font-medium">{b.ad}</div>
                  <div className="mt-0.5 text-xs text-muted-foreground">{b.tarih}</div>
                </div>
                <span className="shrink-0 rounded-full bg-warning/20 px-2 py-0.5 text-xs font-medium text-foreground">
                  {b.kalan}
                </span>
              </div>
            ))
          )}
        </div>
      </SectionCard>
    </div>
  )
}
